<template>
  <el-dialog
    title="引用信息模板"
    :visible.sync="visible"
    width="80%"
    @close="$emit('update:show', false)"
    @open="opened"
    :append-to-body="inner"
  >
    <!-- <div class="el-form-item el-form--label-left" label="搜索对象" v-if="multiple">
      <label class="el-form-item__label" style="width: 80px;">搜索对象</label>
      <div class="el-form-item__content">
        <el-radio-group v-model="search_table">
          <el-radio label="item">零件</el-radio>
          <el-radio label="device">设备</el-radio>
        </el-radio-group>
      </div>
    </div>-->
    <div class="dialog-content">
      <el-table v-if="temps.length > 0" :data="temps" style="width: 100%">
        <el-table-column prop="name" label="模板名称"> </el-table-column>
        <el-table-column prop="content" label="模板内容">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              plain
              @click="deleteTemp(scope.$index)"
              :loading="submiting"
              >删除</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="selectTemp(scope.row)"
              >选用此模板</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="text-info-12">还未设置模板。</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  itemList,
  createItem,
  itemCategoryList,
  ramarkTempList,
  remarkTempList,
  deleteRemarkTemp,
} from '../service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      loading: false,
      visible: this.show,
      temps: [],
      submiting: false,
    }
  },
  created() {},
  methods: {
    async requestTemps() {
      let res = await remarkTempList()
      if (res.code == 0) {
        this.temps = res.data.list
      }
    },
    async deleteTemp(index) {
      let temp = this.temps[index]
      this.$confirm('确定删除此信息模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let that = this
        deleteRemarkTemp(temp.id).then((res) => {
          if (res.code == 0) {
            that.temps.splice(index, 1)
            that.$message.success('删除成功')
          }
          that.submiting = false
        })
      })
    },
    selectTemp(temp) {
      this.visible = false
      this.$emit('selected', temp)
    },
    opened() {
      this.requestTemps()
    },
  },
}
</script>

<style>
.dialog-content {
  max-height: 60vh;
  overflow: auto;
}
</style>